import { PRESUPUESTADOR_SET_IS_RESERVATION } from '../constants'

export function setIsReservation(boolean) {
    return dispatch => {
        dispatch({
            type: PRESUPUESTADOR_SET_IS_RESERVATION,
            data: boolean
        })
    }
}
